import { t } from '@lingui/core/macro'
import { Plural } from '@lingui/react/macro'
import { RadixDialog } from '@jotta/ui/RadixDialog'
import type { RadixModalProps } from '@jotta/ui/RadixModal'
import { RadixModal } from '@jotta/ui/RadixModal'
import { getFilenameFromPath } from '@jotta/utils/pathUtils'

export interface PermanentlyDeleteDialogProps extends RadixModalProps {
  onConfirm: (paths: string[]) => void
  paths: string[]
}
export const PermanentlyDeleteDialog = ({
  onClose,
  onConfirm,
  paths,
  ...props
}: PermanentlyDeleteDialogProps) => {
  const count = paths.length
  const source = count === 1 ? getFilenameFromPath(paths[0]) : ''

  return (
    <RadixModal onClose={onClose} {...props}>
      <RadixDialog
        data-testid="PermanentlyDeleteDialog"
        onClose={onClose}
        title={count > 1 ? t`Permanently delete ${count} files` : source}
        smallTitle={t`Permanently delete`}
        buttons={[
          {
            action: () => onConfirm(paths),
            label: t`Delete forever`,
            type: 'destructive',
            testId: 'PermanentlyDeleteDialogDeleteButton',
          },
          {
            action: 'close',
            label: t`Cancel`,
            testId: 'PermanentlyDeleteDialogCancelButton',
            type: 'outline',
          },
        ]}
      >
        <Plural
          value={count}
          one="Are you sure you want to remove this file from your trash? This operation can not be undone."
          other="Are you sure you want to remove these files from your trash? This operation can not be undone."
        />
      </RadixDialog>
    </RadixModal>
  )
}
